export default "__VITE_ASSET__BuoLuOKK__"